export default __webpack_public_path__ + "932641dc40e6ca3b9274f9e38945cf05.svg";